import { render, staticRenderFns } from "./UpdateBankDetails.vue?vue&type=template&id=22ec63be"
import script from "./UpdateBankDetails.vue?vue&type=script&lang=js"
export * from "./UpdateBankDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports